import { render, staticRenderFns } from "./acDtl.vue?vue&type=template&id=cbfb7496&scoped=true&"
import script from "./acDtl.vue?vue&type=script&lang=js&"
export * from "./acDtl.vue?vue&type=script&lang=js&"
import style0 from "./acDtl.vue?vue&type=style&index=0&id=cbfb7496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfb7496",
  null
  
)

export default component.exports